module.exports = __webpack_public_path__ + "media/audio6.0cb6f468.wav";